const counties = [
  {
    name: 'Bucks County',
    cities: 'Newtown · Doylestown · Langhorne · Bristol · Quakertown',
  },
  {
    name: 'Montgomery County',
    cities: 'Norristown · King of Prussia · Lansdale · Horsham · Ambler',
  },
  {
    name: 'Chester County',
    cities: 'West Chester · Exton · Phoenixville · Coatesville · Malvern',
  },
  {
    name: 'Delaware County',
    cities: 'Media · Chester · Haverford · Springfield · Upper Darby',
  },
];

const LocationSection = () => {
  return (
    <section className="bg-white py-24" id="locations">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-[#c9a84c]"></div>
          <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Where We Work</span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2 className="text-4xl md:text-5xl font-black text-[#0f0f0f] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Serving Southeastern<br />Pennsylvania
          </h2>
          <p className="text-stone-400 text-sm max-w-xs leading-relaxed">
            Our office is in Newtown, PA — perfectly positioned to serve all four counties with speed and local expertise.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          {/* County list */}
          <div className="w-full lg:w-[42%] space-y-0 border-t border-stone-100">
            {counties.map((county, i) => (
              <div key={county.name} className="border-b border-stone-100 py-6 flex items-start gap-5 group">
                <span className="text-xs text-stone-300 font-bold tracking-widest w-6 shrink-0 mt-0.5">0{i + 1}</span>
                <div>
                  <h3 className="font-bold text-[#0f0f0f] text-base mb-1 group-hover:text-[#c9a84c] transition-colors">{county.name}, PA</h3>
                  <p className="text-stone-400 text-xs leading-relaxed">{county.cities}</p>
                </div>
              </div>
            ))}

            {/* Office info */}
            <div className="pt-8 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center shrink-0 bg-[#0f0f0f]">
                <i className="ri-map-pin-2-fill text-[#c9a84c] text-sm"></i>
              </div>
              <div>
                <p className="font-bold text-[#0f0f0f] text-sm">Our Office</p>
                <p className="text-stone-400 text-sm">842 Durham Rd, Newtown, PA 18940</p>
                <a
                  href="https://maps.google.com/?q=842+Durham+Rd+Newtown+PA+18940"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1 text-[#c9a84c] text-xs font-bold mt-1 hover:underline cursor-pointer"
                >
                  Get Directions
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-external-link-line"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="w-full lg:w-[58%] h-[420px] lg:h-auto overflow-hidden">
            <iframe
              title="Black Dog Settlement - 842 Durham Rd Newtown PA"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3040.5!2d-74.9!3d40.23!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c15f5a5a5a5a5a%3A0x0!2s842+Durham+Rd%2C+Newtown%2C+PA+18940!5e0!3m2!1sen!2sus!4v1680000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '420px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
